import { useStyles as useDrawerLinkStyles } from '../DrawerLinkBase/styles';
import cn from 'clsx';

const DrawerLink: React.FC<React.AnchorHTMLAttributes<HTMLAnchorElement>> = ({
    children,
    className,
    ...anchorProps
}) => {
    const classes = useDrawerLinkStyles();
    return (
        <a className={cn(classes.drawerLink, className)} {...anchorProps}>
            {children}
        </a>
    );
};

export default DrawerLink;
